export * from './Component_TagViewer.js';
//# sourceMappingURL=index.js.map